import { render, staticRenderFns } from "./SanitaryGridPassport.vue?vue&type=template&id=90c7ca68&scoped=true"
import script from "./SanitaryGridPassport.vue?vue&type=script&lang=js"
export * from "./SanitaryGridPassport.vue?vue&type=script&lang=js"
import style0 from "./SanitaryGridPassport.vue?vue&type=style&index=0&id=90c7ca68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c7ca68",
  null
  
)

export default component.exports